import React from 'react';
import { Typography } from '@mui/material';
import LinkMenuIcon from '@/public/icons/link_menu.svg';
import ContentDescription from '@/components/MenuDrawer/MyMenuDrawer/@components/ContentDescription';
import Link from '@/components/@IntranetLibrary/Link';
import { useMypageEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { MypageEventName } from '@/constant/gtm';
import { useTranslation } from 'react-i18next';

const WifiContent = () => {
  const { t } = useTranslation();
  const mypageEventTracker = useMypageEventTracker();

  return (
    <>
      <ContentDescription
        hasVerticalMargin={true}
        sx={{ marginBottom: '16px' }}
      >
        {t('MYPAGE.방문자의 Wi-Fi 사용이 필요한 경우,')}
        <br />
        {t(
          'MYPAGE.아래의 버튼을 눌러 나오는 화면에서 인증 후 사용 가능합니다.',
        )}
        <br />
        {t('MYPAGE.문의사항은 정보보안팀으로 연락 바랍니다.')}
      </ContentDescription>
      <Typography
        sx={{
          fontSize: '14px',
          marginBottom: '28px',
          a: {
            color: 'var(--dk-accent, #0066CC)',
            textDecoration: 'underline',
          },
        }}
        dangerouslySetInnerHTML={{
          __html: t(
            'MYPAGE.임직원은 {WiFi 사용 신청}을 통해 기기 등록 후 사용해 주세요.',
          ).replace(
            /\{([^}]+)\}/,
            (match, inner) => `
              <a
                href="https://fnf.atlassian.net/servicedesk/customer/portal/50/group/158/create/480"
                target="_blank"
                rel="noreferrer"
                onclick="mypageEventTracker(MypageEventName.clickEvent, {
                  area_name: '방문자 와이파이 인증',
                  contents: '${inner}',
                  status: undefined,
                  description: '${inner}',
                })"
              >${inner}</a>`,
          ),
        }}
      />
      <Link
        variant={'primary'}
        href={'https://172.21.1.2:8443/wifi.jsp'}
        target={'_blank'}
        rel={'noreferrer'}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
          marginTop: '24px',
        }}
        onClick={() => {
          // GA Mypage - 32번
          mypageEventTracker(MypageEventName.clickOutLink, {
            area_name: '방문자 와이파이 인증',
            button_text: '인증화면 열기',
          });
        }}
      >
        <LinkMenuIcon width={'20px'} height={'20px'} stroke={'currentColor'} />
        {t('MYPAGE.인증화면 열기')}
      </Link>
    </>
  );
};

export default WifiContent;
